import { render, staticRenderFns } from "./EditCollectionItem.vue?vue&type=template&id=7519fa7a&scoped=true&"
import script from "./EditCollectionItem.vue?vue&type=script&lang=js&"
export * from "./EditCollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./EditCollectionItem.vue?vue&type=style&index=0&id=7519fa7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519fa7a",
  null
  
)

export default component.exports